import { render } from "./OrderDetail.vue?vue&type=template&id=6b11464b&scoped=true&ts=true"
import script from "./OrderDetail.vue?vue&type=script&lang=ts"
export * from "./OrderDetail.vue?vue&type=script&lang=ts"

import "./OrderDetail.vue?vue&type=style&index=0&id=6b11464b&lang=scss&scoped=true"

import exportComponent from "/home/production/domains/monteur.waterluxe.nl/monteur-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b11464b"]])

export default __exports__